import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HrTranslateKey } from '../../translate/hr-translate-key';

@Component({
    selector: 'hr-search-buttons',
    templateUrl: './hr-search-buttons.component.html',
})
export class HrSearchButtonsComponent implements OnInit, OnChanges {
    @Input() searchDisabled?: boolean;
    @Input() idPrefix: string;
    @Input() showClearButton:boolean=true;
    @Output() clearClicked = new EventEmitter<void>();
    @Output() searchClicked = new EventEmitter<void>();

    inputId: string;

    ngOnInit(): void {
        this.inputId = this.idPrefix;
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.idPrefix != null && changes.idPrefix.previousValue !== changes.idPrefix.currentValue) {
            this.setInputId(changes.idPrefix.currentValue);
        }
    }

    private setInputId(idPrefix: string) {
        this.inputId = idPrefix;
    }
    public onClearClicked() {
        this.clearClicked.emit();
    }

    public onSearchClicked() {
        this.searchClicked.emit();
    }

    public get hrKey(): typeof HrTranslateKey {
        return HrTranslateKey;
    }
}
